import Axios, {
  type AxiosRequestConfig,
  type CustomParamsSerializer,
} from 'axios';
import { stringify } from 'qs';
import { message } from '../message';
import { getToken, removeToken } from '../auth';
import Cookies from 'js-cookie';
import { I18N_LOCALE_KEY } from '@/store/i18n';

// 相关配置请参考：www.axios-js.com/zh-cn/docs/#axios-request-config-1
const defaultConfig: AxiosRequestConfig = {
  baseURL: '',
  // 请求超时时间
  timeout: 10000,
  headers: {
    Accept: 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  // 数组格式参数序列化（https://github.com/axios/axios/issues/5142）
  paramsSerializer: {
    serialize: stringify as unknown as CustomParamsSerializer,
  },
};

export const pureHttp = Axios.create(defaultConfig);
export const http = Axios.create(defaultConfig);

http.interceptors.request.use(
  config => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const cookieLocale = Cookies.get(I18N_LOCALE_KEY) || 'zh';
    config.headers[I18N_LOCALE_KEY] = cookieLocale;
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

http.interceptors.response.use(
  response => {
    if (response.data && !response.data?.code) return response.data;
    if (response.data?.code === '200') {
      return response.data.data;
    }
    if (response.data?.code === '500' && response.data.data === 6680) {
      removeToken();
      location.replace(`${location.pathname}#/login?redir=${location.href}`);
    }
    const msg = response.data?.msg || 'Unknown Error';

    if (!response?.config?.silent) {
      message(`${response.data?.code || 0}: ${msg}`, {
        type: 'error',
        duration: 3000,
      });
    }

    throw new Error(msg);
  },
  error => {
    if (!error?.config?.silent) {
      message(
        `${error?.status || 0}: ${error?.response?.data?.message || error?.message || 'Unknown Error'}`,
        { type: 'error', duration: 3000 },
      );
    }
    return Promise.reject(error);
  },
);
